var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSysError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "33px",
    viewBox: "0 0 32 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_sys_error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_sys_error"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C7.18755078,0 0,7.18677541 0,15.9995 C0,24.8122246 7.18755078,32 16,32 C24.8124492,32 32,24.8122246 32,15.9995 C32,7.18677541 24.8124492,0 16,0 Z",
    id: "Path",
    fill: "#B80105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7956364,19.2635152 C22.4947879,19.9626667 22.4947879,21.0962424 21.7956364,21.7953939 C21.4455758,22.1454545 20.9888485,22.32 20.5301818,22.32 C20.0705455,22.32 19.6138182,22.1454545 19.2637576,21.7953939 L16.0075152,18.5391515 L12.7483636,21.7953939 C12.0492121,22.4945455 10.9166061,22.4945455 10.2164848,21.7953939 C9.51733333,21.0962424 9.51733333,19.9626667 10.2164848,19.2635152 L13.473697,16.0072727 L10.2164848,12.7481212 C9.51733333,12.0489697 9.51733333,10.9163636 10.2164848,10.2172121 C10.9166061,9.51709091 12.0492121,9.51709091 12.7483636,10.2172121 L16.0075152,13.4734545 L19.2637576,10.2172121 C19.9629091,9.51709091 21.0964848,9.51709091 21.7956364,10.2172121 C22.4947879,10.9163636 22.4947879,12.0489697 21.7956364,12.7481212 L18.5393939,16.0072727 L21.7956364,19.2635152 Z",
    id: "path-3",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSysError);
export default __webpack_public_path__ + "static/media/ic_sys_error.4a79be17ec28342eb8c518bbc2e0ce9f.svg";
export { ForwardRef as ReactComponent };